// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1d8Mu","content":"styles_content__2ETNv"};